/** @jsxImportSource @emotion/react */

import { PropsWithChildren, useEffect, useRef } from "react"

type Props = {
  visible?: boolean
}

export const ScrollTo: React.FC<PropsWithChildren<Props>> = ({ children, visible = true }) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current != null && visible) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "center"
      })
    }
  }, [visible])

  return <div ref={ref}>{children}</div>
}
